<template>
  <div class="assign-tabs">
    <div class="item" :class="{selected: selected===1 }" @click="setSelected(1)">
      <div class="text">Solo Driver</div>
      <div class="footer-line"></div>
    </div>
    <div class="item" :class="{selected: selected===2 }" @click="setSelected(2)">
      <div class="text">Team Driver</div>
      <div class="footer-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "assign-tabs",
  props: {
    callback: Function
  },
  data: () => {
    return {
      selected: 1
    }
  },
  methods: {
    setSelected(index) {
      this.selected = index;
      this.callback(index)
    }
  }
}
</script>

<style scoped lang="scss">
  .assign-tabs {
    height: 42px;
    display: flex;
    margin-top: 16px;
    padding-left: 24px;

    .item {
      padding-top: 4px;
      cursor: pointer;
      &:first-child {
        margin-right: 26px;
      }
      .text {
        font-weight: 600;
        font-size: 14px;
        color: #4C556C;
        height: 22px;
        line-height: 22px;
        padding: 0 6px;
      }
      .footer-line {
        margin-top: 13px;
        height: 3px;
        border-radius: 4px 4px 0px 0px;
      }
      &.selected {
        .text {
          color: #4066D4;
        }
        .footer-line {
          background-color: #4066D4;
        }
      }
    }
  }

</style>
